<script>
	import SiteMain from '$lib/component/site/site-main.svelte';
	import Link from '$lib/component/element/link.svelte';
 
	export let data;
	
	console.log( data )
 </script>

<SiteMain id='error' class='error'>
	<div class='grid grid-max-2'>
		<div class='z-[2] col-span-full row-span-full grid w-[100%] h-[100%] [background-color:rgba(0,0,0,.75)]'>
			<div class='[place-self:center_center]'>
				<h1>404</h1>
				<h2>Page Not Found</h2>
				<p>We apologize for the inconvenience. <br />The requested page could not be found. <br />Please return to the home page to continue browsing.</p>
				<p>
					<Link href='/'>
						Return Home
					</Link>
				</p>
			</div>
		</div>
		<video class='z-[1] col-span-full row-span-full w-auto h-[100%] aspect-video object-cover object-center sm:h-[130%] md:w-[100%] md:h-[100%] md:[object-position:right_bottom] md:object-auto' autoplay muted playsinline loop poster='/lib/image/video-cover.jpg'>
			<source src="lib/video/zmax-video.mp4" type="video/mp4">
		</video>
	</div>
</SiteMain>

<style lang='scss'>

	:global( :where( .error ) ) {
		text-align: center;
		color: var(--clr-white-static);
		grid-template-columns: 1fr;
	}

	:global( :where( .error ) > * ) {
		grid-column: 1 / -1;
		grid-row: 1 / -1;
		text-align: center;
	}


	:global( :where( .error ) h1 ) { 
		font-size: 300px !important;
		font-family: 'Gilroy-Black';
	}

	:global( :where( .error ) h2 ) { 
		font-size: 120px;
		font-family: 'Gilroy-Black';
		margin-top: -60px;
	}

	:global( :where( .error ) p ) { 
		margin-top: 24px;
	}

</style>